import { Component } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    year: number;
    /**
     * Constructor
     */
    constructor() {
        this.year = new Date().getFullYear();
    }
}
